// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"474c2175","34":"6dc1ddf3","267":"b65a1051","409":"1c034142","872":"6a176eef"}[chunkId] + ".chunk.js";
};